export const BREADCRUMB_SET_ITEMS = "@breadcrumb.set.items";
